const Scope = Object.freeze({
  SENTENCE: 'Sentence',
  PARAGRAPH: 'Paragraph',
  DOCUMENT: 'Document',
  TOPIC: 'Topic',
  NONE: 'None'
})
export default Scope
// RESERVE BELOW
